import { useAppDispatch, useAppSelector } from "app/hooks";
import { setAutoRotate } from "features/krpano/details-slice";
import Switch from "shared/components/Switch";

interface AutoRotateProps {}

/**
 * Switch to control the Auto Rotate feature in the panorama viewer
 */
const AutoRotate: React.FC<AutoRotateProps> = () => {
  const autoRotate = useAppSelector((state) => state.krpano.autoRotate);

  const dispatch = useAppDispatch();
  const handleSetAutoRotate = (newValue: Parameters<typeof setAutoRotate>[0]) =>
    dispatch(setAutoRotate(newValue));

  return (
    <Switch
      name="AutoRotateToggle"
      size="smallMedium"
      checked={autoRotate}
      onChange={handleSetAutoRotate}
    />
  );
};
export default AutoRotate;
